<!-- 协作项目 -->
<template>
    <div class="more">
        <template v-if="courseList.length>0">
            <div class="courseBox flex-between">
                <div class="courseItem flex-column" v-for="(item,index) in courseList" :key="index"
                    @click="goLive(item.video)">
                    <img :src="downloadURLImg+item.cover" alt="" v-if="item.cover">
                    <img src="../assets/course/course-cover05.jpg" alt="" v-else>
                    <span class="course_name ui-nowrap-flex">{{item.name}}</span>
                    <span class="name ">{{item.teacherName}}</span>
                </div>
                <div class="courseItem2 flex-column"></div>
                <div class="courseItem2 flex-column"></div>
            </div>
            <div class="pages">
                <el-pagination background layout="prev, pager, next" :total="total" :page-size='pageSize'
                @current-change="currentChange">
                </el-pagination>
            </div>
        </template>
        <el-empty description="暂无课程" v-else></el-empty>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                index: 0,
                courseList: [],
                total: '',
                pageSize:12,
                page:1
            }
        },
        methods: {
            goDetail() {
                this.$router.push('/home/courseDetail2')
            },
            getCourseList() {
                let data = {
                    matchId: 1,
                    page: this.page,
                    limit: this.pageSize,
                }
                Api.Home.listActivity(data)
                    .then(res => {
                        console.log('专题活动:', res);
                        this.courseList = res.data.records;
                        this.total = res.data.total
                    })
                    .catch(err => {
                        console.log('专题活动失败:', err)
                    })
            },
            goLive(url) {
                let query = {
                    url
                }
                this.$router.push({
                    path: '/home/courseDetail2',
                    query
                })
            },
            currentChange(page){
                console.log(page);
                this.page = page;
                this.getCourseList()
            },
            // prev(page){
            //     console.log(page)
            // },
            // next(page){
            //     console.log(page)
            // }
        },
        mounted() {
            this.getCourseList()
        },
    };
</script>
<style lang='less' scoped>
    .more {
        width: 1200px;
        margin: 50px auto;

        .courseBox {
            flex-wrap: wrap;
            .courseItem {
                width: 360px;
                height: 280px;
                background: #FFFFFF;
                box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
                margin-bottom: 20px;
                img {
                    width: 100%;
                    height: 200px;
                }

                .course_name {
                    font-size: 18px;
                    color: #353535;
                    margin: 10px;
                    line-height: 27px;
                    // text-wrap: nowrap;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                }

                .name {
                    color: #999999;
                    font-size: 14px;
                    margin-right: 20px;
                    margin-left: auto;
                }
            }
            .courseItem2{
                width: 360px;
                height: 0;
            }
        }

        .pages {
            margin: 20px auto;
            display: flex;
            align-items: center;
            justify-content: space-around;
        }

    }
</style>